<template>
  <div>
    <div v-if="!mobile" id="base">
      <div style="width: 100%" class="borda-direita borda-esquerda borda-acima">
        <div class="q-pa-sm">
          <q-img
            v-if="$store.state.autenticacao.logo.logoImpressao"
            :src="$store.state.autenticacao.logo.logoImpressao"
            class="img-logo"
            fit="contain"
            crossorigin="*"
          />
          <img
            v-else
            class="img-logo"
            src="../../../assets/MULTPEX_VETOR.png"
            crossorigin="*"
          />
        </div>
      </div>
      <div
        class="row col-12 items-center justify-center q-py-md borda-direita borda-esquerda borda-baixo"
      >
        <span class="text-h6 text-weight-bold texto-titulo"
          >TERMO DE RETIRADA DE EQUIPAMENTOS</span
        >
      </div>
      <div
        class="row col-12 texto-cabecalho items-center borda-direita borda-esquerda borda-baixo"
      >
        <div
          class="row col text-h6 texto-subtitulo text-weight-bold borda-direita"
        >
          <span class="borda-direita q-py-md row col justify-center"
            >DATA DE IMPRESSÃO: {{ data.dataAtual }}</span
          >
          <span class="q-py-md row col justify-center"
            >DATA DE CRIAÇÃO:
            {{
              dadosTransferencia?.dadosBasicos?.criadoEm
                ?.split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}</span
          >
        </div>
        <span
          class="row col justify-center text-h6 texto-subtitulo text-weight-bold"
          >Nº TRANSFERÊNCIA:
          {{ dadosTransferencia?.dadosBasicos?.numero }}</span
        >
      </div>
      <div
        class="row col-12 texto-cabecalho borda-direita borda-esquerda borda-baixo"
      >
        <span class="row col-1 justify-center text-weight-bold borda-direita">{{
          transferencia?.origem.origemTipo == "unidade"
            ? "UNIDADE ORIGEM"
            : "FORNECEDOR ORIGEM"
        }}</span>
        <span class="row col-7 items-center text-weight-bold borda-direita"
          ><span class="q-ml-xs">{{ transferencia?.origem?.nome }}</span></span
        >
        <span class="row col items-center text-weight-bold"
          ><span class="q-ml-xs">CNPJ: {{ transferencia?.origem?.cnpj }}</span>
        </span>
      </div>
      <div
        class="row col-12 items-center texto-cabecalho justify-center borda-direita borda-esquerda borda-baixo"
      >
        <span class="row col-1 justify-center text-weight-bold borda-direita"
          >ENDEREÇO</span
        >
        <span class="row col-8 text-weight-bold borda-direita"
          ><span class="q-ml-xs"
            >Rua: {{ dadoFornecedor.dadoLocalizacaoOrigem?.rua }}</span
          ></span
        >
        <span class="row col text-weight-bold"
          ><span class="q-ml-xs"
            >Numero: {{ dadoFornecedor.dadoLocalizacaoOrigem?.numero }}</span
          >
        </span>
      </div>
      <div
        class="row col-12 items-center texto-cabecalho justify-center borda-direita borda-esquerda borda-baixo"
      >
        <span class="row col-1 justify-center text-weight-bold borda-direita"
          >CIDADE</span
        >
        <span class="row col-2 justify-center text-weight-bold borda-direita"
          ><span>{{ dadoFornecedor.dadoLocalizacaoOrigem?.cidade }}</span></span
        >
        <span class="row col-3 justify-center text-weight-bold borda-direita"
          ><span>ESTADO</span></span
        >
        <span class="row col text-weight-bold"
          ><span class="q-ml-xs">{{
            dadoFornecedor.dadoLocalizacaoOrigem?.estado?.toUpperCase()
          }}</span>
        </span>
      </div>
      <div
        class="row col-12 items-center justify-center borda-direita borda-esquerda borda-baixo"
      >
        <span class="container-branco"></span>
      </div>
      <div
        class="row col-12 items-center justify-center borda-direita borda-esquerda borda-baixo"
      >
        <span class="texto-cabecalho text-weight-bold"
          >MÁQUINAS, EQUIPAMENTOS E ACESSÓRIOS</span
        >
      </div>
      <div
        class="row col-12 items-center justify-center borda-direita borda-esquerda borda-baixo"
      >
        <span class="container-branco"></span>
      </div>
      <div
        style="width: 100%"
        class="items-center texto-cabecalho borda-direita borda-esquerda borda-baixo"
      >
        <div class="row">
          <span
            style="width: 5%"
            class="row justify-center items-center text-weight-bold borda-direita"
            >ITEM</span
          >
          <span
            style="width: 10%"
            class="row justify-center items-center text-weight-bold borda-direita"
            ><span>CÓDIGO</span></span
          >
          <span
            style="width: 15%"
            class="row justify-center items-center text-weight-bold borda-direita"
            ><span>DESCRIÇÃO</span></span
          >
          <span
            style="width: 15%"
            class="row justify-center items-center text-weight-bold borda-direita"
            ><span>{{ "LOCALIZAÇÃO ANTERIOR" }}</span></span
          >
          <span
            style="width: 10%"
            class="row justify-center items-center text-weight-bold borda-direita"
            ><span>{{
              transferencia.destino.destinoTipo == "unidade"
                ? "UNIDADE DESTINO"
                : "FORNECEDOR DESTINO"
            }}</span></span
          >
          <span
            style="width: 10%"
            class="row justify-center items-center text-weight-bold borda-direita"
            ><span>PATRIMÔNIO</span></span
          >
          <span
            style="width: 10%"
            class="row justify-center items-center text-weight-bold borda-direita"
            ><span>PATRIMÔNIO SUB</span></span
          >
          <span
            style="width: 10%"
            class="row justify-center items-center borda-direita text-weight-bold"
            ><span>OPERAÇÃO</span></span
          >
          <span
            style="width: 15%"
            class="row justify-center items-center text-weight-bold"
            ><span>ACESSÓRIOS</span></span
          >
        </div>
      </div>
      <div
        style="width: 100%"
        v-for="(ativo, index) in dadosTransferencia?.ativos"
        :key="index"
      >
        <div
          class="row texto-cabecalho borda-direita borda-esquerda borda-baixo"
        >
          <span
            style="width: 5%"
            class="row justify-center items-center text-weight-bold borda-direita"
            >{{ index + 1 }}</span
          >
          <span
            style="width: 10%"
            class="row justify-center items-center text-weight-bold borda-direita"
            ><span>{{ ativo?.ativoFinal?.catalogoItem?.codigo }}</span></span
          >
          <span
            style="width: 15%"
            class="row justify-center items-center text-weight-bold borda-direita"
            ><span>{{ ativo?.ativoFinal?.catalogoItem?.nome }}</span></span
          >
          <span
            style="width: 15%"
            class="row justify-center items-center text-weight-bold borda-direita"
            ><span
              v-for="(localizacaoAnterior, index) in listaUnidadeAnterior"
              :key="index"
            >
              <span v-if="localizacaoAnterior.ativoUuid == ativo?.ativoUuid">
                {{ localizacaoAnterior.valorInicial }}
              </span>
            </span></span
          >
          <span
            style="width: 10%"
            class="row justify-center items-center text-weight-bold borda-direita"
            ><span>{{
              dadosTransferencia?.dadosBasicos?.unidadeNomeDestino ||
              dadosTransferencia?.dadosBasicos?.fornecedorNomeDestino
            }}</span></span
          >
          <div
            style="width: 10%"
            class="row justify-center items-center text-weight-bold borda-direita"
          >
            <span>{{ ativo?.ativoInicial?.patrimonio || "Nenhum" }}</span>
          </div>
          <div
            style="width: 10%"
            class="row justify-center items-center text-weight-bold borda-direita"
          >
            <span>{{ ativo?.ativoFinal?.patrimonio || "Nenhum" }}</span>
          </div>
          <span
            style="width: 10%"
            class="row justify-center items-center text-weight-bold borda-direita"
            ><span>{{ ativo?.operacao?.nome }}</span></span
          >
          <span style="width: 15%" class="row text-bold">
            <div
              class="q-ml-sm"
              v-if="ativo?.respostasAcessorioEnvio?.length > 0"
            >
              <div
                v-for="(acessorio, index) in ativo?.respostasAcessorioEnvio"
                :key="index"
              >
                <div>
                  <span
                    >{{ acessorio?.nome }} -
                    {{
                      acessorio?.resposta == "sim" ? "Presente" : "Ausente"
                    }}</span
                  >
                </div>
              </div>
            </div>
          </span>
        </div>
      </div>
      <div
        class="row col-12 items-center borda-direita borda-esquerda borda-baixo"
      >
        <span class="texto-cabecalho text-weight-bold q-ml-xs"
          >OBSERVAÇÃO: {{ dadosTransferencia?.dadosBasicos?.observacao }}</span
        >
      </div>
      <div style="width: 100%" class="row border-top texto-cabecalho">
        <div class="column borda-direita" style="width: 50%">
          <div style="width: 100%" class="row borda-baixo borda-esquerda">
            <span
              style="width: 30%"
              class="borda-direita text-weight-bold q-pl-sm"
              >NOME:</span
            >
            <span
              v-if="dadoPessoas?.transportador?.nome"
              class="row justify-center text-weight-bold"
              style="width: 70%"
              >{{ dadoPessoas?.transportador?.nome }}</span
            >
          </div>
          <div class="row borda-baixo" style="width: 100%">
            <span
              style="width: 30%"
              class="borda-direita borda-esquerda text-weight-bold q-pl-sm"
              >MATRICULA:</span
            >
            <span
              class="row justify-center text-weight-bold"
              style="width: 70%"
              >{{ dadoPessoas?.transportador?.documento }}</span
            >
          </div>
          <div class="row borda-baixo container-assinatura">
            <span
              style="width: 30%"
              class="text-weight-bold borda-esquerda borda-direita q-pl-sm row items-center"
              >ASSINATURA:</span
            >
            <span style="width: 70%"></span>
          </div>
        </div>
        <div class="column" style="width: 50%">
          <div style="width: 100%" class="row borda-baixo borda-direita">
            <span
              style="width: 30%"
              class="text-weight-bold borda-direita q-pl-sm"
              >NOME:</span
            >
            <span
              class="row justify-center text-weight-bold"
              style="width: 70%"
            ></span>
          </div>
          <div class="row borda-baixo">
            <span
              style="width: 30%"
              class="text-weight-bold borda-direita q-pl-sm"
              >MATRICULA:</span
            >
            <span
              class="row justify-center text-weight-bold borda-direita"
              style="width: 70%"
            ></span>
          </div>
          <div class="row borda-baixo container-assinatura">
            <span
              style="width: 30%"
              class="text-weight-bold borda-direita q-pl-sm row items-center"
              >ASSINATURA:</span
            >
            <span style="width: 70%" class="borda-direita"></span>
          </div>
        </div>
      </div>
      <div
        style="width: 100%"
        class="row borda-baixo borda-esquerda borda-direita"
      >
        <div style="width: 50%">
          <span
            class="text-weight-bold borda-direita row justify-center q-pl-sm"
            style="width: 100%"
            >RESPONSÁVEL</span
          >
        </div>
        <div style="width: 50%">
          <span
            class="text-weight-bold row justify-center q-pl-sm"
            style="width: 100%"
            >RECEBIDO POR</span
          >
        </div>
      </div>
    </div>
    <div v-else style="width: 100%; height: 100%; overflow: scroll">
      <div id="base-mobile" class="borda-total">
        <div>
          <div class="q-pa-sm">
            <q-img
              v-if="$store.state.autenticacao.logo.logoImpressao"
              :src="$store.state.autenticacao.logo.logoImpressao"
              class="img-logo"
              fit="contain"
              crossorigin="*"
            />
            <img
              v-else
              class="img-logo"
              src="../../../assets/MULTPEX_VETOR.png"
              crossorigin="*"
              fit="contain"
            />
          </div>
        </div>
        <div class="row col-12 items-center justify-center q-py-md borda-baixo">
          <span class="text-h6 text-weight-bold texto-titulo"
            >TERMO DE RETIRADA DE EQUIPAMENTOS</span
          >
        </div>
        <div class="row col-12 texto-cabecalho items-center borda-baixo">
          <div
            class="row col text-h6 texto-subtitulo text-weight-bold borda-direita"
          >
            <span class="borda-direita q-py-md row col justify-center"
              >DATA DE IMPRESSÃO: {{ data.dataAtual }}</span
            >
            <span class="q-py-md row col justify-center"
              >DATA DE CRIAÇÃO:
              {{
                dadosTransferencia?.dadosBasicos?.criadoEm
                  ?.split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}</span
            >
          </div>
          <span
            class="row col justify-center text-h6 texto-subtitulo text-weight-bold"
            >Nº TRANSFERÊNCIA:
            {{ dadosTransferencia?.dadosBasicos?.numero }}</span
          >
        </div>
        <div class="row col-12 texto-cabecalho borda-baixo">
          <span
            class="row col-1 justify-center text-weight-bold borda-direita"
            >{{
              transferencia?.origem.origemTipo == "unidade"
                ? "UNIDADE ORIGEM"
                : "FORNECEDOR ORIGEM"
            }}</span
          >
          <span class="row col-7 items-center text-weight-bold borda-direita"
            ><span class="q-ml-xs">{{
              transferencia?.origem?.nome
            }}</span></span
          >
          <span class="row col items-center text-weight-bold"
            ><span class="q-ml-xs"
              >CNPJ: {{ transferencia?.origem?.cnpj }}</span
            >
          </span>
        </div>
        <div
          class="row col-12 items-center texto-cabecalho justify-center borda-baixo"
        >
          <span class="row col-1 justify-center text-weight-bold borda-direita"
            >ENDEREÇO</span
          >
          <span class="row col-8 text-weight-bold borda-direita"
            ><span class="q-ml-xs"
              >Rua: {{ dadoFornecedor.dadoLocalizacaoOrigem?.rua }}</span
            ></span
          >
          <span class="row col text-weight-bold"
            ><span class="q-ml-xs"
              >Numero: {{ dadoFornecedor.dadoLocalizacaoOrigem?.numero }}</span
            >
          </span>
        </div>
        <div
          class="row col-12 items-center texto-cabecalho justify-center borda-baixo"
        >
          <span class="row col-1 justify-center text-weight-bold borda-direita"
            >CIDADE</span
          >
          <span class="row col-2 justify-center text-weight-bold borda-direita"
            ><span>{{
              dadoFornecedor.dadoLocalizacaoOrigem?.cidade
            }}</span></span
          >
          <span class="row col-3 justify-center text-weight-bold borda-direita"
            ><span>ESTADO</span></span
          >
          <span class="row col text-weight-bold"
            ><span class="q-ml-xs">{{
              dadoFornecedor.dadoLocalizacaoOrigem?.estado?.toUpperCase()
            }}</span>
          </span>
        </div>
        <div class="row col-12 items-center justify-center borda-baixo">
          <span class="container-branco"></span>
        </div>
        <div class="row col-12 items-center justify-center borda-baixo">
          <span class="texto-cabecalho text-weight-bold"
            >MÁQUINAS, EQUIPAMENTOS E ACESSÓRIOS</span
          >
        </div>
        <div class="row col-12 items-center justify-center borda-baixo">
          <span class="container-branco"></span>
        </div>
        <div
          style="width: 100%"
          class="items-center texto-cabecalho borda-direita borda-esquerda borda-baixo"
        >
          <div class="row">
            <span
              style="width: 5%"
              class="row justify-center items-center text-weight-bold borda-direita"
              >ITEM</span
            >
            <span
              style="width: 10%"
              class="row justify-center items-center text-weight-bold borda-direita"
              ><span>CÓDIGO</span></span
            >
            <span
              style="width: 15%"
              class="row justify-center items-center text-weight-bold borda-direita"
              ><span>DESCRIÇÃO</span></span
            >
            <span
              style="width: 15%"
              class="row justify-center items-center text-weight-bold borda-direita"
              ><span>LOCALIZAÇÃO ANTERIOR</span></span
            >
            <span
              style="width: 10%"
              class="row justify-center items-center text-weight-bold borda-direita"
              ><span>{{
                transferencia.destino.destinoTipo == "unidade"
                  ? "UNIDADE DESTINO"
                  : "FORNECEDOR DESTINO"
              }}</span></span
            >
            <span
              style="width: 10%"
              class="row justify-center items-center text-weight-bold borda-direita"
              ><span>PATRIMÔNIO</span></span
            >
            <span
              style="width: 10%"
              class="row justify-center items-center text-weight-bold borda-direita"
              ><span>PATRIMÔNIO SUB</span></span
            >
            <span
              style="width: 10%"
              class="row justify-center items-center borda-direita text-weight-bold"
              ><span>OPERAÇÃO</span></span
            >
            <span
              style="width: 15%"
              class="row justify-center items-center text-weight-bold"
              ><span>ACESSÓRIOS</span></span
            >
          </div>
        </div>
        <div
          style="width: 100%"
          v-for="(ativo, index) in dadosTransferencia?.ativos"
          :key="index"
        >
          <div
            class="row texto-cabecalho borda-direita borda-esquerda borda-baixo"
          >
            <span
              style="width: 5%"
              class="row justify-center items-center text-weight-bold borda-direita"
              >{{ index + 1 }}</span
            >
            <span
              style="width: 10%"
              class="row justify-center items-center text-weight-bold borda-direita"
              ><span>{{ ativo?.ativoFinal?.catalogoItem?.codigo }}</span></span
            >
            <span
              style="width: 15%"
              class="row justify-center items-center text-weight-bold borda-direita"
              ><span>{{ ativo?.ativoFinal?.catalogoItem?.nome }}</span></span
            >
            <span
              style="width: 15%"
              class="row justify-center items-center text-weight-bold borda-direita"
              ><span
                v-for="(localizacaoAnterior, index) in listaUnidadeAnterior"
                :key="index"
              >
                <span v-if="localizacaoAnterior.ativoUuid == ativo?.ativoUuid">
                  {{ localizacaoAnterior.valorInicial }}
                </span>
              </span></span
            >
            <span
              style="width: 10%"
              class="row justify-center items-center text-weight-bold borda-direita"
              ><span>{{
                dadosTransferencia?.dadosBasicos?.unidadeNomeDestino ||
                dadosTransferencia?.dadosBasicos?.fornecedorNomeDestino
              }}</span></span
            >
            <div
              style="width: 10%"
              class="row justify-center items-center text-weight-bold borda-direita"
            >
              <span>{{ ativo?.ativoInicial?.patrimonio || "Nenhum" }}</span>
            </div>
            <div
              style="width: 10%"
              class="row justify-center items-center text-weight-bold borda-direita"
            >
              <span>{{ ativo?.ativoFinal?.patrimonio || "Nenhum" }}</span>
            </div>
            <span
              style="width: 10%"
              class="row justify-center items-center text-weight-bold borda-direita"
              ><span>{{ ativo?.operacao?.nome }}</span></span
            >
            <span style="width: 15%" class="row text-bold">
              <div
                class="q-ml-sm"
                v-if="ativo?.respostasAcessorioEnvio?.length > 0"
              >
                <div
                  v-for="(acessorio, index) in ativo?.respostasAcessorioEnvio"
                  :key="index"
                >
                  <div>
                    <span
                      >{{ acessorio?.nome }} -
                      {{
                        acessorio?.resposta == "sim" ? "Presente" : "Ausente"
                      }}</span
                    >
                  </div>
                </div>
              </div>
            </span>
          </div>
        </div>
        <div class="row col-12 items-center borda-baixo">
          <span class="texto-cabecalho text-weight-bold q-ml-xs"
            >OBSERVAÇÃO:
            {{ dadosTransferencia?.dadosBasicos?.observacao }}</span
          >
        </div>
        <div style="width: 100%" class="row border-top texto-cabecalho">
          <div class="column borda-direita" style="width: 50%">
            <div style="width: 100%" class="row borda-baixo">
              <span
                style="width: 30%"
                class="borda-direita text-weight-bold q-pl-sm"
                >NOME:</span
              >
              <span
                v-if="dadoPessoas?.transportador?.nome"
                class="row justify-center text-weight-bold"
                style="width: 70%"
                >{{ dadoPessoas?.transportador?.nome }}</span
              >
            </div>
            <div class="row borda-baixo" style="width: 100%">
              <span
                style="width: 30%"
                class="borda-direita text-weight-bold q-pl-sm"
                >MATRICULA:</span
              >
              <span
                class="row justify-center text-weight-bold"
                v-if="dadoPessoas?.transportador?.documento"
                style="width: 70%"
                >{{ dadoPessoas?.transportador?.documento }}</span
              >
            </div>
            <div class="row borda-baixo container-assinatura">
              <span
                style="width: 30%"
                class="text-weight-bold borda-direita q-pl-sm row items-center"
                >ASSINATURA:</span
              >
              <span style="width: 70%"></span>
            </div>
          </div>
          <div class="column" style="width: 50%">
            <div style="width: 100%" class="row borda-baixo">
              <span
                style="width: 30%"
                class="text-weight-bold borda-direita q-pl-sm"
                >NOME:</span
              >
              <span
                class="row justify-center text-weight-bold"
                style="width: 70%"
              ></span>
            </div>
            <div class="row borda-baixo">
              <span
                style="width: 30%"
                class="text-weight-bold borda-direita q-pl-sm"
                >MATRICULA:</span
              >
              <span
                class="row justify-center text-weight-bold"
                style="width: 70%"
              ></span>
            </div>
            <div class="row borda-baixo container-assinatura">
              <span
                style="width: 30%"
                class="text-weight-bold borda-direita q-pl-sm row items-center"
                >ASSINATURA:</span
              >
              <span style="width: 70%"></span>
            </div>
          </div>
        </div>
        <div style="width: 100%" class="row">
          <div style="width: 50%">
            <span
              class="text-weight-bold borda-direita row justify-center q-pl-sm"
              style="width: 100%"
              >RESPONSÁVEL</span
            >
          </div>
          <div style="width: 50%">
            <span
              class="text-weight-bold row justify-center q-pl-sm"
              style="width: 100%"
              >RECEBIDO POR</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

export default {
  setup() {
    const store = useStore();
    const $route = useRoute();
    const quasar = useQuasar();

    const dadosTransferencia = ref();
    const dadoPessoas = ref({
      expedidor: {},
      solicitante: {},
      transportador: {},
    });
    const dadoFornecedor = ref({
      dadoLocalizacaoOrigem: {},
      dadoLocalizacaoDestino: {},
    });
    const data = ref({
      dataAtual: new Date().toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }),
    });
    const transferencia = ref({
      origem: { nome: "", id: "", origemTipo: "" },
      destino: { nome: "", id: "", destinoTipo: "" },
    });
    const listaUnidadeAnterior = ref([]);
    const transferenciaId = $route.params.transferenciaId;
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const detalharTransferenciaExterna = async () => {
      try {
        store.dispatch("pdt/hiddenHeader", false);
        const response = await store.dispatch(
          "ferramentaria/detalharTransferencia",
          {
            transferenciaUuid: transferenciaId,
          }
        );
        dadosTransferencia.value = response.data.resultado.dados;
        dadosTransferencia.value.ativos.sort((a, b) => {
          if (
            a.ativoFinal.catalogoItem.codigo > b.ativoFinal.catalogoItem.codigo
          ) {
            return 1;
          }
          if (
            a.ativoFinal.catalogoItem.codigo < b.ativoFinal.catalogoItem.codigo
          ) {
            return -1;
          }
          return 0;
        });
        montarDadoPessoa(
          dadosTransferencia.value.pessoas,
          dadosTransferencia.value.transportador
        );
        adicionarNomeAcessorioObjetoResposta();
        transferencia.value = {
          origem: {
            origemTipo:
              dadosTransferencia.value?.dadosBasicos.unidadeNomeOrigem !=
                null &&
              dadosTransferencia.value?.dadosBasicos.unidadeNomeOrigem != ""
                ? "unidade"
                : "fornecedor",
            nome:
              dadosTransferencia.value?.dadosBasicos.unidadeNomeOrigem ||
              dadosTransferencia.value?.dadosBasicos.fornecedorNomeOrigem,
            id:
              dadosTransferencia.value?.dadosBasicos.unidadeIdOrigem ||
              dadosTransferencia.value?.dadosBasicos.fornecedorIdOrigem,
          },
          destino: {
            destinoTipo:
              dadosTransferencia.value?.dadosBasicos.unidadeNomeDestino !=
                null &&
              dadosTransferencia.value?.dadosBasicos.unidadeNomeDestino != ""
                ? "unidade"
                : "fornecedor",
            nome:
              dadosTransferencia.value?.dadosBasicos.unidadeNomeDestino ||
              dadosTransferencia.value?.dadosBasicos.fornecedorNomeDestino,
            id:
              dadosTransferencia.value?.dadosBasicos.unidadeIdDestino ||
              dadosTransferencia.value?.dadosBasicos.fornecedorIdDestino,
          },
        };
        buscarFornecedor(
          dadosTransferencia.value.dadosBasicos.fornecedorIdOrigem ||
            dadosTransferencia.value.dadosBasicos.fornecedorIdDestino,
          dadosTransferencia.value.dadosBasicos.unidadeIdOrigem ||
            dadosTransferencia.value.dadosBasicos.unidadeIdDestino
        );
        receberUnidadeAnterior(dadosTransferencia.value.dadosBasicos.criadoEm);
        transferencia.value.origem.origemTipo == "unidade"
          ? buscarUnidade(
              transferencia.value.origem.id,
              "dadoLocalizacaoOrigem"
            )
          : buscarFornecedor(
              transferencia.value.origem.id,
              transferencia.value.destino.id,
              "dadoLocalizacaoOrigem"
            );
        if (mobile.value) {
          zoomOut();
        }
        salvarPdf();
      } catch (error) {
        console.log(error);
      }
    };

    const zoomOut = () => {
      const content = document.getElementById("base-mobile");
      content.style.transform = "scale(1)";
      content.style.width = `400%`;
      content.style.height = `100%`;
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      const centerX = (windowWidth - content.clientWidth) / 2;
      const centerY = (windowHeight - content.clientHeight) / 2;

      content.style.transformOrigin = "top left";
      content.style.left = centerX + "px";
      content.style.top = centerY + "px";
    };

    const salvarPdf = async () => {
      quasar.notify({
        message: "Aguarde enquanto o PDF é gerado.",
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
      setTimeout(() => {
        let data = document.getElementById(
          mobile.value ? "base-mobile" : "base"
        );
        var hoje = new Date();
        let dataGerado = `${hoje.getDate()}/${hoje.getMonth()}/${hoje.getFullYear()} ${hoje.getHours()}:${hoje.getMinutes()}:${hoje.getMilliseconds()}`;
        html2canvas(data, {
          useCORS: true,
        }).then((canvas) => {
          var imgWidth = 210;
          var pageHeight = 295;
          var imgHeight = (canvas.height * imgWidth) / canvas.width;

          var heightLeft = imgHeight;
          const imgData = canvas.toDataURL("image/jpeg");

          var doc = new jsPDF("p", "mm", "a4", true);
          var position = 2;
          doc.addImage(
            imgData,
            "JPEG",
            1,
            position,
            imgWidth - 2,
            imgHeight + 2
          );
          heightLeft -= pageHeight;

          while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            doc.addPage();
            doc.addImage(
              imgData,
              "JPEG",
              1,
              position,
              imgWidth - 2,
              imgHeight + 2
            );
            heightLeft -= pageHeight;
          }
          doc.save(
            `transferencia_externa_${dadosTransferencia?.value?.dadosBasicos?.numero}_${dataGerado}`
          );
        });
      }, 2000);
    };

    const montarDadoPessoa = (array, transportador) => {
      let expedidor = array.filter((pessoa) => pessoa.tipo == "expedidor");
      let solicitante = array.filter((pessoa) => pessoa.tipo == "solicitante");
      dadoPessoas.value = {
        expedidor: expedidor[0],
        transportador: transportador,
        solicitante: solicitante[0],
      };
    };

    const buscarFornecedor = async (idFornecedor, unidadeId, localizacao) => {
      try {
        const response = await store.dispatch("ter/listarParceiros", {
          unidadeId: unidadeId,
        });
        let listaFornecedor = response.response.data.resultado.dados;
        let arrayFornecedor = listaFornecedor.filter(
          (fornecedor) => fornecedor.parceiroId == idFornecedor
        );
        dadoFornecedor.value[localizacao] = {
          cep: arrayFornecedor[0]?.cep,
          cidade: arrayFornecedor[0]?.cidade,
          cnpj: arrayFornecedor[0]?.cnpj,
          estado: arrayFornecedor[0]?.estado,
          inscricaoEstadual: arrayFornecedor[0]?.inscricaoEstadual,
          nome: arrayFornecedor[0]?.nome,
          numero: arrayFornecedor[0]?.numero,
          parceiroId: arrayFornecedor[0]?.parceiroId,
          razaoSocial: arrayFornecedor[0]?.razaoSocial,
          rua: arrayFornecedor[0]?.rua,
          unidadeId: arrayFornecedor[0]?.unidadeId,
          unidadeNome: arrayFornecedor[0]?.unidadeNome,
        };
      } catch (error) {
        console.log(error);
      }
    };

    const buscarUnidade = async (id, localizacao) => {
      try {
        const response = await store.dispatch("org/listarUnidades");
        let unidades = response.listaUnidades;
        let unidadeEspecifica = unidades.filter((unidade) => unidade.id == id);
        dadoFornecedor.value[localizacao] = {
          bairro: unidadeEspecifica[0]?.endereco?.bairro,
          cep: unidadeEspecifica[0]?.endereco?.cep,
          rua: unidadeEspecifica[0]?.endereco?.endereco,
          cidade: unidadeEspecifica[0]?.endereco?.municipio,
          estado: unidadeEspecifica[0]?.endereco?.uf,
          unidadeId: unidadeEspecifica[0]?.endereco?.unidadeId,
        };
      } catch (error) {
        console.log(error);
      }
    };

    const listarHistoricoAtivo = async (ativoUuid, dataTransferencia) => {
      try {
        const response = await store.dispatch(
          "ferramentaria/listarMovimentacaoAtivo",
          {
            ativoUuid,
            chave: "unidadeId",
          }
        );
        if (response.data.resultado.dados.length > 0) {
          response.data.resultado.dados.forEach((dadoHistorico) => {
            if (
              converterStringParaData(dataTransferencia) >
              converterStringParaData(dadoHistorico?.alteradoEm)
            ) {
              let ativoIndice = dadosTransferencia.value?.ativos.findIndex(
                (ativoDado) => ativoDado.ativoUuid === ativoUuid
              );
              if (
                ativoIndice !== -1 &&
                !listaUnidadeAnterior.value.some(
                  (unidade) =>
                    unidade.ativoUuid ==
                    dadosTransferencia.value?.ativos[ativoIndice].ativoUuid
                )
              ) {
                listaUnidadeAnterior.value.push(dadoHistorico);
                return;
              }
            }
          });
        }
      } catch (error) {
        console.log(error);
      }
    };

    const adicionarNomeAcessorioObjetoResposta = () => {
      dadosTransferencia.value.ativos.forEach((ativo) => {
        if (ativo.respostasAcessorioEnvio.length > 0) {
          ativo.respostasAcessorioEnvio.forEach((acessorio) => {
            let nome = ativo.ativoInicial.acessorios.filter(
              (value) => value.uuid === acessorio.ativoAcessorioUuid
            );
            acessorio.nome = nome[0].nome;
          });
        }
      });
    };

    const receberUnidadeAnterior = (dataTransferencia) => {
      dadosTransferencia.value.ativos.forEach((ativo) => {
        listarHistoricoAtivo(ativo.ativoFinal.ativoUuid, dataTransferencia);
      });
    };

    const converterStringParaData = (data) => {
      const partesDataHora = data.split(" ");
      const partesData = partesDataHora[0].split("-");
      const partesHora = partesDataHora[1]
        ? partesDataHora[1].split(":")
        : [0, 0, 0];

      return new Date(
        partesData[0],
        partesData[1],
        partesData[2],
        partesHora[0],
        partesHora[1],
        partesHora[2]
      );
    };

    onMounted(() => {
      detalharTransferenciaExterna();
    });

    return {
      detalharTransferenciaExterna,
      dadosTransferencia,
      dadoPessoas,
      buscarUnidade,
      listaUnidadeAnterior,
      receberUnidadeAnterior,
      montarDadoPessoa,
      buscarFornecedor,
      converterStringParaData,
      salvarPdf,
      adicionarNomeAcessorioObjetoResposta,
      dadoFornecedor,
      data,
      mobile,
      transferencia,
      listarHistoricoAtivo,
    };
  },
};
</script>

<style scoped>
.borda-total {
  border: 2px solid black;
}
.borda-direita {
  border-right: 2px solid black;
}
.borda-acima {
  border-top: 2px solid black;
}
.borda-esquerda {
  border-left: 2px solid black;
}
.borda-baixo {
  border-bottom: 2px solid black;
}
.img-logo {
  height: 20%;
  width: 20%;
}
.texto-cabecalho {
  font-size: 15px;
}
.container-branco {
  height: 15px;
}
.container-assinatura {
  height: 60px;
}
@page {
  margin: 0.9mm;
  size: 210mm 290.7mm;
}
@media print {
  .texto-cabecalho {
    font-size: 9px;
  }
  .container-branco {
    height: 13px;
  }
  .container-assinatura {
    height: 50px;
  }
  .texto-titulo {
    font-size: 15px;
  }
  .texto-subtitulo {
    font-size: 11px;
  }
}
</style>
